import type { ProColumns } from "@ant-design/pro-components";
import { ActionView } from "action-view";
import type { TTableProps } from "../../../dataTypes";
export function createActionColumn<T extends Record<string, unknown>>(
  buildRowActions: TTableProps<T>["buildRowActions"],
  maxVisibleRowActions = 1,
): ProColumns<T> | undefined {
  if (!buildRowActions) return undefined;
  return {
    title: "Actions",
    valueType: "option",
    // fixed: "right",
    render: (_: unknown, record: T) => {
      const actions = buildRowActions(record);

      return <ActionView actions={actions} maxVisible={maxVisibleRowActions} />;
    },
  };
}
